import { IconProps } from '@euler/app/components/icons/types';
import { FC, memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const StoreInfoIcon: FC<IconProps> = memo(
  ({ width, height, size, color, style }) => {
    return (
      <Svg
        viewBox="0 0 72 72"
        width={width ?? size}
        height={height ?? size}
        style={style}
      >
        <Path
          d="M61.0035 20.1042L44.7278 3.82857C44.2741 3.37479 43.6615 3.11765 43.0186 3.11765H10.8909C9.55222 3.11765 8.4707 4.19916 8.4707 5.53781V64.4622C8.4707 65.8008 9.55222 66.8824 10.8909 66.8824H59.2942C60.6329 66.8824 61.7144 65.8008 61.7144 64.4622V21.821C61.7144 21.1782 61.4573 20.558 61.0035 20.1042ZM56.1329 22.9328H41.8993V8.69916L56.1329 22.9328ZM56.269 61.437H13.9161V8.56302H36.7564V24.8992C36.7564 25.7416 37.0911 26.5496 37.6868 27.1453C38.2825 27.741 39.0904 28.0756 39.9329 28.0756H56.269V61.437ZM34.4875 45.0168H20.5715C20.2388 45.0168 19.9665 45.2891 19.9665 45.6218V49.2521C19.9665 49.5849 20.2388 49.8571 20.5715 49.8571H34.4875C34.8203 49.8571 35.0926 49.5849 35.0926 49.2521V45.6218C35.0926 45.2891 34.8203 45.0168 34.4875 45.0168ZM19.9665 35.3361V38.9664C19.9665 39.2992 20.2388 39.5714 20.5715 39.5714H49.6136C49.9463 39.5714 50.2186 39.2992 50.2186 38.9664V35.3361C50.2186 35.0034 49.9463 34.7311 49.6136 34.7311H20.5715C20.2388 34.7311 19.9665 35.0034 19.9665 35.3361Z"
          fill={color}
        />
      </Svg>
    );
  },
);
